export enum TransitionStatus {
  PENDING = "PENDING",
  PROMOTED = "PROMOTED",
  REPEATED = "REPEATED",
  TRANSFERRED_OUT = "TRANSFERRED_OUT",
  GRADUATED = "GRADUATED",
}
